module.exports = __webpack_public_path__ + "img/wlw.294a7a97.png";